import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconColorDirective } from '../icon/directives/icon-color.directive';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-icon-help',
  templateUrl: './icon-help.component.html',
  styleUrls: ['./icon-help.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconColorDirective, IconComponent],
})
export class IconHelpComponent {}
